export function getIconFromDashboardName(dashboardName: string) {
  const nameToIconMapping: Record<string, string> = {
    'Investment Mix': 'light:circle-dollar-to-slot',
    'DORA Metrics': 'light:chart-line',
    KTLO: 'light:heart-pulse',
    Delivery: 'light:code-pull-request',
  }

  if (dashboardName in nameToIconMapping) {
    return nameToIconMapping[dashboardName]
  } else {
    return 'light:square-poll-vertical'
  }
}
